export const categorizeGrants = (items = []) => {
    const openGrants = [];
    const closedGrants = [];

    items.forEach((grant) => {
        if (!grant?.isActive) {
            return;
        }

        if (grant.nextDeadline) {
            openGrants.push(grant);
        } else {
            closedGrants.push(grant);
        }
    });

    return {
        openGrants,
        closedGrants
    };
};

/**
 * Determine whether a single grant entry is open.
 * Mirrors the logic used in categorizeGrants.
 *
 * @param {Object} grant - Craft entry representing a grant.
 * @returns {boolean} true when the grant is active and has a next deadline.
 */
export const isGrantOpen = (grant = {}) => {
    if (!grant?.isActive) {
        return false;
    }

    return Boolean(grant.nextDeadline);
};

